import { post, get } from '@integec/fetch-task'

export const getTotalErcotMapping = targetInfo =>
  get(targetInfo, 'total/total-ercot-mapping')

export const postTotalErcotMapping = targetInfo => data =>
  post(targetInfo, 'total/total-ercot-mapping')(data)

export const deletTotalErcotMapping = targetInfo => data =>
  post(targetInfo, 'total/total-ercot-mapping/delete')(data)
